"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootFromObj = void 0;
var section_1 = require("./section");
var page_1 = require("./page");
function rootFromObj(obj) {
    return {
        pages: (obj.pages || []).map(page_1.pageFromObj),
        sections: (obj.sections || []).map(section_1.sectionFromObj),
        videoUrl: obj.videoUrl || '',
    };
}
exports.rootFromObj = rootFromObj;
